/**
 * ga-desc-split.js — AccountReroll v11
 * Transforme chaque <li> de la description en un mini-accordéon natif.
 * Chargé en defer — s'exécute après le DOM.
 */
(function () {
  'use strict';

  function buildAccordion(titleHTML, bodyHTML, isFirst) {
    var wrapper = document.createElement('div');
    wrapper.className = 'ga-desc-acc';

    var details = document.createElement('details');
    if (isFirst) details.open = true;

    var summary = document.createElement('summary');
    summary.className = 'ga-desc-acc__summary';
    summary.innerHTML =
      '<span class="ga-desc-acc__title">' + titleHTML + '</span>' +
      '<svg class="ga-desc-acc__caret" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="18" height="18" aria-hidden="true"><polyline points="5 8 10 13 15 8"/></svg>';

    var body = document.createElement('div');
    body.className = 'ga-desc-acc__body';
    body.innerHTML = bodyHTML;

    details.appendChild(summary);
    details.appendChild(body);
    wrapper.appendChild(details);
    return wrapper;
  }

  function splitDescription() {
    var sectionId = window.__ga_section_id;
    var descDetails = null;

    /* Chercher l'accordéon Description par ID */
    if (sectionId) {
      descDetails = document.querySelector('#Details-Description-' + sectionId);
    }

    /* Fallback: chercher par texte du titre */
    if (!descDetails) {
      var allDetails = document.querySelectorAll('.product__accordion details');
      for (var i = 0; i < allDetails.length; i++) {
        var titleEl = allDetails[i].querySelector('.accordion__title');
        if (titleEl && titleEl.textContent.trim() === 'Description') {
          descDetails = allDetails[i];
          break;
        }
      }
    }

    if (!descDetails) return;

    var contentEl = descDetails.querySelector('.accordion__content.rte');
    if (!contentEl) return;

    /* Chercher les <li> de premier niveau */
    var rootUl = contentEl.querySelector('ul');
    if (!rootUl) return;

    var items = Array.prototype.slice.call(rootUl.querySelectorAll(':scope > li'));
    if (items.length < 2) return;

    var container = document.createElement('div');
    container.className = 'ga-desc-split';

    items.forEach(function (li, j) {
      var titleNodes = [];
      var bodyNodes  = [];
      var passedBreak = false;

      Array.prototype.forEach.call(li.childNodes, function (node) {
        if (!passedBreak) {
          if (node.nodeName === 'UL' || node.nodeName === 'OL') {
            passedBreak = true;
            bodyNodes.push(node);
          } else if (node.nodeName === 'BR') {
            passedBreak = true;
          } else {
            titleNodes.push(node);
          }
        } else {
          bodyNodes.push(node);
        }
      });

      /* Construire le HTML du titre */
      var tmp = document.createElement('div');
      titleNodes.forEach(function (n) { tmp.appendChild(n.cloneNode(true)); });
      var titleHTML = tmp.innerHTML.trim() || li.textContent.trim().split('\n')[0].trim();

      /* Construire le HTML du corps */
      var tmp2 = document.createElement('div');
      bodyNodes.forEach(function (n) { tmp2.appendChild(n.cloneNode(true)); });
      var bodyHTML = tmp2.innerHTML.trim();

      container.appendChild(buildAccordion(titleHTML, bodyHTML, j === 0));
    });

    /* Remplacer uniquement si au moins 2 accordéons générés */
    if (container.querySelectorAll('.ga-desc-acc').length >= 2) {
      contentEl.innerHTML = '';
      contentEl.appendChild(container);
    }
  }

  function run() {
    if (!document.querySelector('.product__info-container')) return;
    splitDescription();
  }

  /* Le script est chargé en defer, donc DOM est prêt */
  run();

  /* Support Shopify section reload (theme editor) */
  document.addEventListener('shopify:section:load', function () {
    setTimeout(run, 100);
  });

}());
